import Vue from 'vue'
import apiService from '../../services/ApiService'
import merchantActions from './merchants'
import { i18n } from '../../main'

export default {
  async signIn(context, credentials) {
    try {
      const { data: result } = await apiService.signIn(credentials.email, credentials.password)
      if (result && result.success) {
        context.commit('setUser', result.data)

        if (credentials.rememberMe) localStorage.setItem('token', result.data.token)

        let name = 'ChangeRole'
        switch (result.data.loggedRole.type) {
          case 'user':
            break
          case 'merchant':
            name = 'MerchantDashboard'
            break
          case 'npo':
            name = 'NpoDashboard'
            break
        }
        context.commit('goTo', { name })
      } else {
        if (result.error && result.error.message) throw Error(result.error.message)
        else throw Error(i18n.tc('errors.something_wrong'))
      }
    } catch (error) {
      if (error && error.message) Vue.toasted.show(error.message)
    }
  },
  async getMe(context, credentials) {
    try {
      if (credentials.refreshToken) {
        const { data: result } = await apiService.getMe(credentials.refreshToken)
        if (result && result.success) {
          context.commit('setUser', result.data)

          let name = 'UserDashboard'
          switch (result.data.loggedRole.type) {
            case 'user':
              break
            case 'merchant':
              name = 'MerchantDashboard'
              break
            case 'npo':
              name = 'NpoDashboard'
              break
          }
          context.commit('goTo', { name })
        } else {
          if (result.error && result.error.message) throw Error(result.error.message)
          else throw Error(i18n.tc('errors.something_wrong'))
        }
      }
    } catch (error) {
      if (error && error.message) Vue.toasted.show(error.message)
    }
  },
  async getRoles(context) {
    try {
      const { data: result } = await apiService.getRoles()
      if (result && result.success) {
        context.commit('setRoles', result.data)
      } else {
        if (result.error && result.error.message) throw Error(result.error.message)
        else throw Error(i18n.tc('errors.something_wrong'))
      }
    } catch (error) {
      if (error && error.message) Vue.toasted.show(error.message)
    }
  },
  async changeRole(context, roleId) {
    try {
      const { data: result } = await apiService.changeRole(roleId)
      if (result && result.success) {
        context.commit('setUser', result.data)

        localStorage.removeItem('token')

        let name = 'UserDashboard'
        switch (result.data.loggedRole.type) {
          case 'user':
            break
          case 'merchant':
            name = 'MerchantDashboard'
            break
          case 'npo':
            name = 'NpoDashboard'
            break
        }
        context.commit('goTo', { name })
      } else {
        if (result.error && result.error.message) throw Error(result.error.message)
        else throw Error(i18n.tc('errors.something_wrong'))
      }
    } catch (error) {
      if (error && error.message) Vue.toasted.show(error.message)
    }
  },
  async forgotPassword(context, credentials) {
    try {
      const { data: result } = await apiService.sendForgot(credentials)
      if (result && result.success) {
        Vue.toasted.success(i18n.tc('messages.mail_sent'))
      } else {
        if (result.error && result.error.message) throw Error(result.error.message)
        else throw Error(i18n.tc('errors.something_wrong'))
      }
    } catch (error) {
      if (error && error.message) Vue.toasted.show(error.message)
    }
  },
  async renewPassword(context, newPwd) {
    try {
      const { data: result } = await apiService.newPassword(newPwd)
      if (result && result.success) {
        Vue.toasted.success(i18n.tc('messages.pwd_renewed'))
        context.commit('goTo', { name: 'Login' })
      } else {
        if (result.error && result.error.message) throw Error(result.error.message)
        else throw Error(i18n.tc('errors.something_wrong'))
      }
    } catch (error) {
      if (error && error.message) Vue.toasted.show(error.message)
    }
  },
  async changeProfileImg(context, data) {
    try {
      const { data: result } = await apiService.changeProfileImg(data.type, data.profileId, data.blob)
      if (result && result.success) {
        if (data.type === 'merchants') context.commit('setMerchant', result.data)
        else context.commit('setNpo', result.data)
      } else {
        if (result.error && result.error.message) throw Error(result.error.message)
        else throw Error(i18n.tc('errors.something_wrong'))
      }
    } catch (error) {
      if (error && error.message) Vue.toasted.show(error.message)
    }
  },
  async changeCoverImg(context, data) {
    try {
      const { data: result } = await apiService.changeCoverImg(data.type, data.profileId, data.blob)
      if (result && result.success) {
        context.commit('setMerchant', result.data)
      } else {
        if (result.error && result.error.message) throw Error(result.error.message)
        else throw Error(i18n.tc('errors.something_wrong'))
      }
    } catch (error) {
      if (error && error.message) Vue.toasted.show(error.message)
    }
  },
  ...merchantActions
}



// WEBPACK FOOTER //
// ./src/store/actions/index.js